/* eslint-disable lingui/no-unlocalized-strings */
import ReactGA from "react-ga4";

// 初始化 GA
export const initGA = () => {
  try {
    const gaId = import.meta.env.VITE_GA_ID;

    if (process.env.NODE_ENV === "development") {
      console.log("[DEV] GA ID:", gaId);
      return;
    }

    if (process.env.NODE_ENV === "production" && gaId) {
      ReactGA.initialize(gaId);
    }
  } catch (error) {
    console.error("GA initialization error:", error);
  }
};

// 记录页面访问
export const logPageView = (path: string) => {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log("[DEV] Page view:", path);
      return;
    }

    if (process.env.NODE_ENV === "production") {
      ReactGA.send({ hitType: "pageview", page: path });
    }
  } catch (error) {
    console.error("Page view tracking error:", error);
  }
};
